import axios from '../axios/axiosConfig';
import { getGeneralProjectTotalPages } from '../redux/api/generalProjectPagination';

export const isCheckedOut = value => value === true || value === 1 || ['true', 'yes', '1'].includes(String(value || '').trim().toLowerCase());

export function checkoutRecordUrl(endpoint, jobId) {
  const url = new URL(endpoint);
  if (jobId === undefined || jobId === null || !String(jobId).trim()) throw new Error('Job ID is required');
  url.searchParams.set('id', String(jobId));
  return url.href;
}

// Fail closed: an invalid list must never be interpreted as an unlocked job.
export async function fetchCheckedOutJobs(endpoint, signal) {
  // Do not let a missing configuration become a request to the browser origin.
  new URL(endpoint);
  const records = [];
  let totalPages = 1;
  for (let page = 1; page <= totalPages; page++) {
    const { data } = await axios.get(endpoint, { params: { checkedOut: true, page }, signal });
    const rows = Array.isArray(data) ? data : data?.data ?? data?.Data ?? data?.items ?? data?.Items;
    if (!Array.isArray(rows) || rows.some(row => !row || typeof row !== 'object' || Array.isArray(row) || row.ID == null)) {
      throw new Error('Invalid checked-out jobs response');
    }
    if (page === 1) {
      totalPages = getGeneralProjectTotalPages(data?.pagination ?? data?.Pagination ?? data);
      if (totalPages > 1000) throw new Error('Checked-out jobs response exceeds pagination limit');
    }
    records.push(...rows.filter(row => isCheckedOut(row.IsCheckedOut)));
  }
  return [...new Map(records.map(row => [String(row.ID), row])).values()];
}
